import { createContext, useContext } from 'react';
import { billing, engagement, identity, platform } from '@platform/contracts';
import { PLATFORM_TENANT } from '@platform/authz';
/** Bearer + tenant headers for every authenticated call. Missing pieces are simply absent. */
export async function authHeaders(session, app) {
    const headers = {};
    const token = await session.getAccessToken();
    if (token)
        headers['authorization'] = `Bearer ${token}`;
    const tenantId = app === 'admin' ? PLATFORM_TENANT : session.getTenantId();
    if (tenantId)
        headers['x-tenant-id'] = tenantId;
    return headers;
}
export function createApiClients(options) {
    const base = `${options.origin ?? ''}${options.config.api.basePath}`;
    const common = options.fetchImpl
        ? { fetch: options.fetchImpl }
        : {};
    const authed = (context) => ({
        ...common,
        baseUrl: `${base}/${context}`,
        headers: () => authHeaders(options.session, options.config.app),
    });
    return {
        identity: identity.createIdentityClient(authed('identity')),
        platform: platform.createPlatformClient(authed('platform')),
        billing: billing.createBillingClient(authed('billing')),
        engagement: engagement.createEngagementClient(authed('engagement')),
        public: { platform: platform.createPlatformClient({ ...common, baseUrl: `${base}/platform` }) },
    };
}
const ApiContext = createContext(null);
export const ApiProvider = ApiContext.Provider;
export function useApi() {
    const api = useContext(ApiContext);
    if (!api)
        throw new Error('useApi must be used inside <ApiProvider>');
    return api;
}
//# sourceMappingURL=clients.js.map